import './full-slider.scss'
import { slideOut, slideIn } from './full-slider-tween.js'
import { loadImage } from 'js/utility/image.js'

export default {
    name: 'full-slider',

    data: {
        index: 0,
        interactions: true,
        smallTitleHidden: false,
        titleHidden: false,
        slideTimeout: null
    },

    computed: {
        currentSlide () {
            if (this.slides && this.slides.length) {
                return this.slides[this.index]
            } else {
                return null
            }
        }
    },

    mounted () {
        this.toggleSlideTimeout()
    },

    methods: {
        toggleSlideTimeout () {
            clearTimeout(this.slideTimeout)
            this.slideTimeout = setTimeout(() => {
                if (this.slides && this.slides.length) {
                    const nextIndex = (this.index + 1 === this.slides.length) ? 0 : this.index + 1
                    this.toggleSlide(nextIndex)
                }
            }, 5000)
        },

        toggleSlide (i) {
            if (i === this.index) {
                return
            }
            if (!this.interactions) {
                return
            }

            clearTimeout(this.slideTimeout)
            this.interactions = false
            const imageUrl = this.slides[i].image ? this.slides[i].image.sizes.wide : null

            Promise.resolve()
                .then(() => slideOut.call(this))
                .then(() => {
                    this.index = i
                    return imageUrl ? loadImage(imageUrl) : Promise.resolve()
                })
                .then(() => slideIn.call(this))
                .then(() => {
                    this.interactions = true
                    this.toggleSlideTimeout()
                })
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/full-slider/full-slider.js